import { render, staticRenderFns } from "./CalculateTest.vue?vue&type=template&id=0022ac11&"
import script from "./CalculateTest.vue?vue&type=script&lang=js&"
export * from "./CalculateTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports